<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Front" class="d-icon d-icon--front" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.223 5.45a3.302 3.302 0 0 1 3.302-3.302h10.59v4.7a1.65 1.65 0 0 1-1.65 1.651h-4.33a1.588 1.588 0 0 0-1.561 1.566v10.279c0 .912-.74 1.65-1.651 1.65h-4.7V5.452z" fill="#001B38"/><path d="M8.914 10.127a4.287 4.287 0 1 0 8.574 0 4.287 4.287 0 0 0-8.574 0z" :fill="`url(#${uniqueID}a)`"/><path opacity=".5" d="M8.914 10.127a4.287 4.287 0 1 0 8.574 0 4.287 4.287 0 0 0-8.574 0z" :fill="`url(#${uniqueID}b)`"/><defs><linearGradient :id="`${uniqueID}a`" x1="10.182" y1="6.913" x2="16.629" y2="13.404" gradientUnits="userSpaceOnUse"><stop stop-color="#FF0057" stop-opacity=".16"/><stop offset=".861" stop-color="#FF0057"/></linearGradient><linearGradient :id="`${uniqueID}b`" x1="10.182" y1="6.913" x2="16.629" y2="13.404" gradientUnits="userSpaceOnUse"><stop stop-color="#FF0057" stop-opacity=".16"/><stop offset=".861" stop-color="#FF0057"/></linearGradient></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconFront',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
